// Route path constants. Single source of truth so the rest of the app does
// `navigate(ROUTES.chat)` and never typos a path. Lives outside routes.tsx
// so that file can stay pure-component (react-refresh requirement).

export const ROUTES = {
  landing: "/",
  signup: "/signup",
  login: "/login",
  checkEmail: "/check-email",
  verifyEmail: "/verify-email",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  chat: "/chat",
  recommendation: "/recommendation",
  account: "/account",
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
